<template>
  <div class="ShowPresentation">

    <presentation-breadcrumbs :items="[{text: 'Info'}]">
    </presentation-breadcrumbs>

    <presentation-toolbar :presentation="presentation">
    </presentation-toolbar>

    <presentation-info-card :presentation="presentation">
    </presentation-info-card>

    <presentation-access-card :presentation="presentation">
    </presentation-access-card>

    <presentation-permissions-card :presentation="presentation">
    </presentation-permissions-card>

    <presentation-sharing-card :presentation="presentation">
    </presentation-sharing-card>

    <presentation-settings-card :presentation="presentation">
    </presentation-settings-card>
  </div>
</template>
<script>
import {mapGetters} from 'vuex';
import StatusChip from "../../components/StatusChip";
import find from 'lodash/find';
import PresentationToolbar from "./components/PresentationToolbar";
import PresentationBreadcrumbs from "./components/PresentationBreadcrumbs";
import _ from "lodash";
import shareThemeService from "../../../../ml/services/shareThemeService";
import PresentationIcon from "./components/PresentationIcon";
import PresentationInfoCard from "./components/PresentationInfoCard";
import PresentationAccessCard from "./components/PresentationAccessCard";
import PresentationPermissionsCard from "./components/PresentationPermissionsCard";
import PresentationSharingCard from "./components/PresentationSharingCard";
import PresentationPublishingCard from "./components/PresentationPublishingCard";
import PresentationSettingsCard from "./components/PresentationSettingsCard";

export default {
  components: {PresentationSettingsCard, PresentationPublishingCard, PresentationSharingCard, PresentationPermissionsCard, PresentationAccessCard, PresentationInfoCard, PresentationIcon, PresentationBreadcrumbs, PresentationToolbar, StatusChip},
  props: {
    presentation: {
      type: Object,
      required: true,
    },
  },
  metaInfo() {
    this.$store.commit('setTitle', this.presentation.name);
    return {
      title: this.$store.getters.title,
    }
  },
  data() {
    return {
      breadcrumbs: [
        {text: 'Presentations', exact: true, to: {name: 'presentations'},},
        {text: 'Show'},
      ],
    }
  },
  computed: {
    ...mapGetters([
      'shareTemplates',
      'team',
      'users',
    ]),
  },
}
</script>
